import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

const SnowflakeServiceUserDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.connected_email && (
        <RelatedUserSection
          entityData={entityData}
          contextName="snowflake service user - nhi details view"
        />
      )}
      {!entityData?.connected_email &&
        entityData?.snowflake_service_user?.email && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Email</Typography>
            </Box>
            <Box ml={2} display={"flex"}>
              <TextIntegrationStyle
                title={""}
                value={entityData.snowflake_service_user.email}
              />
            </Box>
          </Box>
        )}
      {entityData?.snowflake_service_user?.is_admin !== undefined && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Admin</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData.snowflake_service_user.is_admin ? "True" : "False"
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.snowflake_service_user?.admin_roles?.length > 0 && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Admin Roles</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.snowflake_service_user.admin_roles.map(
              (adminRole, index) => (
                <TextIntegrationStyle
                  key={index}
                  title={""}
                  value={adminRole}
                ></TextIntegrationStyle>
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.snowflake_service_user?.default_role && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Default Role</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title=""
              value={entityData.snowflake_service_user.default_role}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.snowflake_service_user?.default_warehouse && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Default Warehouse</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title=""
              value={entityData.snowflake_service_user.default_warehouse}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.snowflake_service_user?.default_namespace && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Default Namespace</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title=""
              value={entityData.snowflake_service_user.default_namespace}
            />
          </Box>
        </Box>
      )}
      {entityData?.snowflake_service_user?.type && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Type</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.snowflake_service_user?.type
                  ? entityData.snowflake_service_user.type
                  : "None"
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.snowflake_service_user?.status && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Status</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={entityData.snowflake_service_user.status}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SnowflakeServiceUserDetailsView;
